import React, { useCallback, useEffect, useReducer } from 'react'
import { Button, } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import apiCalls from 'src/api/apiCalls';
import Loader from '../shared/loader.component';
import ErrorMessage from '../shared/messages/errorMessage';
import { casesReducer, initialState } from './reducer';
import CaseDocuments from './caseDocuments';
import AuditLogDetails from './auditLogDetails';
import NoData from '../shared/noDataComponent';
import Info from './info';
import CaseViewDetails from './caseViewDetails';
import HeaderComponent from '../header';
import AdminDocuments from './documentForAdmin';
const ViewCases = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [state, dispatch] = useReducer(casesReducer, initialState);
    const {
        caseData,
        documents,
        docRepository,
        replyLoader,
        error,
        loader,
        breadCrumbList,
        docunetDetailId,
        assignedToNames
    } = state;
    useEffect(() => {
        if (id) {
            getCaseView();
        }
    }, [id])
    const fetchAssignedToLu = async (assignedTo) => {
        dispatch({ type: 'SET_LOADER', payload: true });
        dispatch({ type: 'SET_ERROR', payload: null });
        try {
            let assignedIdList = assignedTo;
            let res = await apiCalls.assignedAdmins();
            if (res.ok) {
                dispatch({ type: 'SET_ERROR', payload: null });
                for (let x in assignedIdList) {
                    let data = assignedIdList[x]?.assignedToIds;
                    let namelist = [];
                    for (let i in data) {
                        let nameObj = res.data.find((item) => item.id === data[i]);
                        namelist.push(nameObj?.assignedTo);
                    }
                    assignedIdList[x].assignedTo = namelist.join(", ");
                }
                const assignedNamesString = assignedIdList
                    .map(item => item.assignedTo)
                    .join(", ");
                dispatch({
                    type: 'SET_ASSIGNED_NAMES',
                    payload: assignedNamesString,
                });
            } else {
                dispatch({ type: 'SET_ERROR', payload: apiCalls.isErrorDispaly(res?.data) });
            }
        } catch (error) {
            dispatch({ type: 'SET_ERROR', payload: apiCalls.isErrorDispaly(error) });
        } finally {
            dispatch({ type: 'SET_LOADER', payload: false });
        }
    };
    const getCaseView = async () => {
        dispatch({ type: 'SET_ERROR', payload: null });
        dispatch({ type: 'SET_LOADER', payload: true });
        try {
            const response = await apiCalls.getCasesview(id);
            if (response?.ok) {
                dispatch({ type: 'SET_ERROR', payload: null });
                let obj = response.data;
                obj.assignedTo = response.data?.assignedTo?.map((item) => ({
                    ...item,
                    assignedToIds: item.assignedToIds?.split(",")
                }));
                const checkedDocuments = response.data.caseDetails.filter(doc => doc.isChecked);
                dispatch({
                    type: 'SET_CASE_DATA',
                    payload: {
                        caseData: obj,
                        documents: checkedDocuments,
                    },
                });
                dispatch({
                    type: 'SET_BREADCRUMB',
                    payload: [
                        { id: '1', bname: 'Cases', url: "/cases/casesgrid" },
                        { id: '2', bname: response.data.caseNumber }
                    ]
                });
                await fetchAssignedToLu(obj.assignedTo);
            } else {
                dispatch({ type: 'SET_ERROR', payload: apiCalls.isErrorDispaly(response?.data) });
            }
        } catch (error) {
            dispatch({ type: 'SET_ERROR', payload: apiCalls.isErrorDispaly(error) });
        } finally {
            dispatch({ type: 'SET_LOADER', payload: false });
        }
    };
    const handleCancel = useCallback(() => {
        navigate("/cases/casesgrid")
    }, [navigate])
    const closeError = useCallback(() => {
        dispatch({ type: 'SET_ERROR', payload: null })
    }, [dispatch])
    return (<>
        <HeaderComponent breadCrumbList={breadCrumbList} />
        {loader && <><div className="h-[80vh] flex justify-center items-center"><Loader className="" /></div></>}

        {error && <ErrorMessage msg={error} onClose={closeError} />}
        {!loader && <div>
            <div className='grid md:grid-cols-2 gap-4'>
                <div className=''>
                    <CaseViewDetails caseData={caseData} />
                    <Info caseDetails={caseData} />
                    {caseData?.isAdmin && <div className='border border-StrokeColor rounded-5 p-3.5 mt-4'>
                        <div>
                            <div className=''>
                                <p className='summary-label mb-0.5'>Note :</p>
                                <div className='border border-StrokeColor rounded-5 p-3'>
                                    <p className=' break-words'>{caseData?.note || ''}</p>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {!caseData?.isAdmin && <div className='border border-StrokeColor rounded-5 p-4 mt-7'>
                        <div>
                            <p className='summary-label'>Assigned to</p>
                            <p className='summary-value'>{assignedToNames || 'No assigned users'}  </p>
                        </div>
                    </div>}
                </div>
                <div className='mb-4'>
                    {!caseData?.isAdmin && <h4 className='text-titleColor font-semibold text-2xl mb-1 items-start text-start'>Request for document</h4>}
                    <div className='Custom-collapse xl:p-3 md:p-2 border border-StrokeColor rounded-5'>
                        {documents.length <= 0 && <div className='border border-StrokeColor rounded-5 p-3.5'><NoData /></div>}
                        {(!caseData?.isAdmin && documents.length > 0) && <div className='case-document'> <CaseDocuments
                            documents={documents}
                            docRepository={docRepository}
                            replyLoader={replyLoader}
                            docunetDetailId={docunetDetailId}
                            dispatch={dispatch}
                            caseData={caseData}
                        /></div>}
                        <div className=''>
                            {caseData?.isAdmin && <AdminDocuments
                                documents={documents}
                                docRepository={docRepository}
                                replyLoader={replyLoader}
                                docunetDetailId={docunetDetailId}
                                dispatch={dispatch}
                                caseData={caseData}
                            />}
                        </div>
                    </div>
                </div>
            </div>
            <AuditLogDetails caseDetails={caseData} />
            <div className='text-right mt-5'>
                <Button
                    key="back"
                    type="cancel"
                    className='cancel-btn'
                    onClick={handleCancel}
                >
                    Close
                </Button>
            </div>
        </div>}
    </>)
}
export default ViewCases;